<template>
    <main class="authorization-content authorization-content_bg"> 
      <div class="autorization">
        <div class="autorization__body popup box bg-white">
          <form id="autorization-form" name="autorization-form" @submit.prevent="submitForm" method="post">
            <div class="popup__header">
              <div class="popup__title section__title section__title_style3">{{ $t("welcome") }}</div>
              <div class="popup__logo svg-icon" aria-hidden="true">
                <svg role="img" width="63" height="24" aria-hidden="true">
                  <use xlink:href="#svg-logo-mobile"></use>
                </svg>
              </div>
            </div>
            <div class="popup__body">
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-login-enter">{{ $t("login") }}</label>
                <input class="form-control" :class="{is_invalid: v$.login.$error}" type="text" v-model.trim.lazy="login" name="user-login-enter" id="user-login-enter" :placeholder='$t("login")'>
                <div class="form-alt">{{ $t("altForLogin") }}</div>
                <div class="form-validator" :class="{is_invalid: v$.login.$error}">{{ $t("requiredInput") }}</div>
              </div>
              <div class="form-group" v-if="login && login.length<6">
                <label class="form-label form-label_hidden" for="user-region-enter">{{ $t("region") }}</label>
                <select v-model.trim="region" class="form-control" required name="user-region" id="user-region">
                  <option value="" selected disabled>{{ $t("region") }}</option>
                  <option value="1">Алматы</option>
                  <option value="2">Астана</option>
                  <option value="3">Актобе</option>
                  <option value="4">Атырау</option>
                  <option value="5">Жамбыл (NewTelCom)</option>
                  <option value="6">Кокшетау</option>
                  <option value="7">Караганда</option>
                  <option value="8">Костанай</option>
                  <option value="9">Кызылорда</option>
                  <option value="10">Оскемен</option>
                  <option value="11">Павлодар</option>
                  <option value="12">Семей</option>
                  <option value="14">Шымкент (Дител)</option>
                  <option value="17">Актау</option>
                </select>
              </div>
              <div class="form-group">
                <label class="form-label form-label_hidden" for="user-password-enter">{{ $t("password") }}</label>
                <input class="form-control" :class="{is_invalid: v$.password.$error}" type="password" v-model.trim="password" name="user-password-enter" id="user-password-enter" :placeholder='$t("password")'>
                <div class="form-validator" :class="{is_invalid: v$.password.$error}">{{ $t("requiredInput") }}</div>
              </div>
              <span class="error__message" :class="{invalid_account: isInvalidAccount}">{{ $t("incorrectData") }}</span>
              <span class="error__message" :class="{invalid_account: notActivatedAccount}">{{ $t("notActivatedAccount") }} <span class="btnLink" @click="resendActivate"> ({{ $t("resendMessage") }})</span></span>
            </div>
            <div class="popup__footer">
              <div class="row align-items-center justify-content-between form_footer">
                <div class="col-12 col-sm-auto order-sm-last">
                  <button class="btn btn_default btn_white" type="submit">{{ $t("enter") }}</button>
                </div>
                <div class="col-12 col-sm-auto">
                  <ul class="list list_unstyled autorization__list">
                    <li class="list__item"><router-link class="link" to="/password-recovery">{{ $t("forgotPassword") }}</router-link></li>
                    <li class="list__item" v-if="true"><router-link class="link" to="/registration">{{ $t("registration") }}</router-link></li>
                  </ul>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </main>
    <div class="modal fade modal_message" ref="modalSuccess" aria-label="Операция прошла успешно" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title section__title section__title_style3">
                {{$t("regSuccessTitle")}}
            </div>
            <button class="btn svg-icon modal-close" type="button" data-dismiss="modal" @click="closeModal" :aria-label='$t("close")'>
              <svg role="img" width="14" height="14" aria-hidden="true">
                <use xlink:href="#svg-icon-close"></use>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <div class="section__description color-green">
              <p>{{$t("regSuccessText")}}</p>
            </div>
            <!-- <router-link to="/login" class="btn btn_default btn_white btn_message" tupe="button" data-dismiss="modal">{{ $t("go") }}</router-link> -->
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import useValidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

import {mapActions} from 'vuex'
export default {
  data(){
    return {
      v$: useValidate(),
      login: '',
      region: '',
      password: '',
      isInvalidAccount: false,
      notActivatedAccount: false,
      id_client: ''
    }
  },
  validations() {
  	return {
  		login: { required },
  		password: { required }
  	}
  },
  methods: {
    ...mapActions({
      auth: 'authorization/login',
      resendActivateMessage: 'authorization/sendActivateMessage'
    }),
    submitForm() {
      let authData = {
        login: this.login.includes('@') ? this.login.toLowerCase() : this.region ?  `${this.region}_${this.login}` : this.login,
        password: this.password
      }
      this.isInvalidAccount = false
      this.notActivatedAccount = false
      this.v$.$validate() 
  		if (!this.v$.$error) { 
  			this.auth(authData).then((resp) => {
          if(resp === 200){
            this.$router.push({ name: 'home' })
          }else{
            if (resp.detail === 'User is not active'){
              this.notActivatedAccount = true
              this.id_client = resp.id_client
            }
            else if(resp.detail === 'User has duplicate'){
              toastr.warning(this.$t("message_hasDuplicate"));
            }
            else{
              this.isInvalidAccount = true
            }
          }
        })
  		}
    },
    resendActivate() {
      this.resendActivateMessage({id_client: this.id_client}).then(res => {
        if(res === 200 || res === 201){
          this.$refs.modalSuccess.classList.add('show-modal')
        }else {
          toastr.error("Ошибка")
        }
      })
    },
    closeModal(){
      this.$refs.modalSuccess.classList.remove('show-modal')
    }
  }
}
</script>
<style scoped>
  .is_invalid{
    border: 1px solid #df1717;
    opacity: 1;
    visibility: inherit;
  }
  .error__message{
    font-size: .8em;
    color: #df1717;
    display: none;
  }
  .invalid_account{
    display: block;
  }
  .form_footer div{
    width: 50%;
  }
  .form-alt{
    font-size: 0.7em;
    color: #979797;
    padding-top: 3px;
  }
  .modal_message{
    -webkit-box-shadow: 0px 3px 20px 23px rgba(34, 60, 80, 0.2);
    -moz-box-shadow: 0px 3px 20px 23px rgba(34, 60, 80, 0.2);
    box-shadow: 0px 3px 20px 23px rgba(34, 60, 80, 0.2);
  }
  .modal-body{
    text-align: center !important;
  }
  .show-modal{
    display: block !important;
    opacity: 1 !important;
    background: rgba(255,255,255,.5);
  }
  .btnLink{
    color: blue;
    cursor: pointer;
    text-decoration: underline;
  }
  .form-validator{
    font-size: .8em;
  }
</style>